import { gql } from '@apollo/client';

export const GET_AIRLINES = gql`
  query GetAirlines {
    airlines {
      id
      name
      code
      logo
      sortOrder
      isActive
    }
  }
`;
